import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbNavChangeEvent, } from '@ng-bootstrap/ng-bootstrap';
import { UserModel } from 'src/app/core/models/members/user/user.model';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { GlobalComponent } from 'src/app/global-component';
import { RequisitionListService } from 'src/app/core/services/list-services/requisition-list.service';
// Sweet Alert
import Swal from 'sweetalert2';
import { CheckoutInfoModel } from 'src/app/core/models/cart/checkout-info-model';
import { ProductInfoModel, ProductType } from 'src/app/core/models/cart/product-info-model';
import { CheckoutResultInfoModel } from 'src/app/core/models/cart/checkout-result-info-model';
import { RequisitionModel } from 'src/app/core/models/requisition/requisition.model';
import { AddressModel } from 'src/app/core/models/address.model';
import { DocumentTemplateModel } from 'src/app/core/models/document/document-template-model';
import { CheckoutApiService } from 'src/app/core/services/checkout-api.service';
import { loadStripe } from '@stripe/stripe-js/pure';
import { BadgeCountService } from 'src/app/core/services/badgecount.service';
import { environment } from 'src/environments/environment';
import { RequisitionStatus } from 'src/app/core/enums/requisition-status-enum';

@Component({
  selector: 'app-single-checkout-component',
  templateUrl: './single-checkout-component.component.html',
  styleUrls: ['./single-checkout-component.component.scss']
})
export class SingleCheckoutComponentComponent implements OnInit {

  emailPattern = GlobalComponent.emailPattern;

  submitted = false;

  userModel: UserModel = new UserModel();
  tabId: number = 1;
  isLoading: boolean = false;
  newCard: boolean = false;

  localPaymentElement: any = undefined;
  localCheckout: any = undefined;
  checkoutSessionId: string | undefined = undefined

  @Input() singleRequisitionModel: RequisitionModel | undefined = undefined;
  @Input() singlePackageCheckout: DocumentTemplateModel | undefined = undefined;
  @Input() stripePayment: Boolean = false;

  checkoutSucceeded: boolean = false;

  appearanceModel: any = undefined;

  constructor(
    private modalRef: NgbActiveModal,
    protected badgeCountService: BadgeCountService,
    private checkoutApiService: CheckoutApiService,
    private toasterNotificationService: ToasterNotificationService,
    private myfileApiService: MyfileApiService,
  ) {

  }

  ngOnInit(): void {

    this.myfileApiService.getUser().subscribe((result: UserModel | undefined) => {
      if (result) {
        this.userModel = result;
      }
      if (!this.userModel.paymentInfo.billingAddress) {
        this.userModel.paymentInfo.billingAddress = new AddressModel();
      }
    });
  }

  validatePersonalInfo(): boolean {
    if (
      this.userModel.name && (this.userModel.name != '') &&
      this.userModel.lastName && (this.userModel.lastName != '') &&
      this.userModel.email != undefined && this.emailPattern.test(this.userModel.email) && this.userModel.email != ''
    ) {
      return true
    }
    this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Something went wrong. Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
    return false;
  }

  validateCreditCardInfo(): boolean {
    if (this.userModel.paymentInfo.expiryDate && this.userModel.paymentInfo.expiryDate.length > 5) {
      if (this.userModel.paymentInfo.expiryMonth && this.userModel.paymentInfo.expiryYear) {
        if (this.userModel.paymentInfo.expiryMonth < 10) {
          this.userModel.paymentInfo.expiryDate = `0${this.userModel.paymentInfo.expiryMonth}/${this.userModel.paymentInfo.expiryYear}`
        } else {
          this.userModel.paymentInfo.expiryDate = `${this.userModel.paymentInfo.expiryMonth}/${this.userModel.paymentInfo.expiryYear}`
        }
      }
    }

    if (this.userModel.paymentInfo.creditCardNumber && (this.userModel.paymentInfo.creditCardNumber.length == 15 || this.userModel.paymentInfo.creditCardNumber.length == 16) && !this.userModel.paymentInfo.creditCardNumber.includes(' ')) {
      this.userModel.paymentInfo.creditCardNumber = `${this.userModel.paymentInfo.creditCardNumber.substring(0, 4)} ${this.userModel.paymentInfo.creditCardNumber.substring(4, 8)} ${this.userModel.paymentInfo.creditCardNumber.substring(8, 12)} ${this.userModel.paymentInfo.creditCardNumber.substring(12, this.userModel.paymentInfo.creditCardNumber.length)}`
    }

    if (
      this.userModel.paymentInfo.cardHolderName && (this.userModel.paymentInfo.cardHolderName != '') &&
      this.userModel.paymentInfo.creditCardNumber && (this.userModel.paymentInfo.creditCardNumber != '') && (this.userModel.paymentInfo.creditCardNumber.length == 18 || this.userModel.paymentInfo.creditCardNumber.length == 19) &&
      this.userModel.paymentInfo.cvvNumber && (this.userModel.paymentInfo.cvvNumber.length >= 3) &&
      this.userModel.paymentInfo.expiryDate && (this.userModel.paymentInfo.expiryDate.length == 5)
    ) {
      this.userModel.paymentInfo.expiryMonth = parseInt(this.userModel.paymentInfo.expiryDate.split('/')[0])
      this.userModel.paymentInfo.expiryYear = 2000 + parseInt(this.userModel.paymentInfo.expiryDate.split('/')[1])
      return true
    } else {
      return false
    }
  }

  tabToPayment() {
    this.submitted = true;

    if (this.validatePersonalInfo()) {
      this.userModel.fullName = `${this.userModel.name} ${this.userModel.lastName}`;
      if (!this.userModel.paymentInfo.creditCardNumber) {
        this.newCard = true;
      }
      //check for Stripe JS - if yes, uses fetchClientSecret() that uses StripeJS. 
      // if (this.stripePayment) {
      //   this.fetchClientSecret();
      // } else {
      //  this.tabId = 2;
      //}

      //all doc templates use myfile CC checkout
      this.tabId = 2;
    }
    this.submitted = false;

  }

  rgbToHex(rgbString: string) {
    // Extract numerical values from the string
    var parts = rgbString.substring(rgbString.indexOf('(') + 1, rgbString.indexOf(')')).split(',').map(Number);
    var r = parts[0];
    var g = parts[1];
    var b = parts[2];

    // Helper function to convert a single color component to a two-digit hex string
    var componentToHex = (c: any) => {
      var hex = c.toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    };

    // Combine components into a full hex string
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
  }

  queryAndSetAppearance(): any {

    var footerElement = document.getElementsByClassName("footer")[0];

    var headerText = document.getElementById("hiddenText");

    var formInput = document.getElementById("hiddenInput");

    if (formInput && headerText && footerElement) {
      return {
        theme: undefined,
        rules: {
          '.Input': {
            border: `${window.getComputedStyle(formInput!).getPropertyValue('border')}`,
            color: `${window.getComputedStyle(formInput!).getPropertyValue('color')}`,
            backgroundColor: `${window.getComputedStyle(formInput!).getPropertyValue('background-color')}`
          },
          '.Input:focus': {
            border: '1px solid #ced4da',
            boxShadow: 'none'
          }
        },
        variables: {
          colorPrimary: this.rgbToHex(`${window.getComputedStyle(headerText!).getPropertyValue('color')}`),
          colorText: this.rgbToHex(`${window.getComputedStyle(headerText!).getPropertyValue('color')}`),
          colorBackground: this.rgbToHex(`${window.getComputedStyle(footerElement!).getPropertyValue('background-color')}`),
          colorDanger: '#ed5e5e',
          fontFamily: 'Ideal Sans, system-ui, sans-serif',
          spacingUnit: '2px',
          borderRadius: '4px',
        }
      }
    }

    return {

      theme: undefined,

      rules: {
        '.Input': {
          border: 'var(--vz-primary-rgb)',
          color: 'var(--vz-primary-rgb)',
          backgroundColor: 'var(--vz-primary-rgb)',
        },
        '.Input:focus': {
          border: '1px solid #ced4da',
          boxShadow: 'none'
        }
      },

      variables: {
        colorPrimary: 'var(--vz-primary-rgb)',
        colorText: 'var(--vz-primary-rgb)',
        colorBackground: 'var(--vz-primary-rgb)',
        colorDanger: '#ed5e5e',
        fontFamily: 'Ideal Sans, system-ui, sans-serif',
        spacingUnit: '2px',
        borderRadius: '4px',
      }
    }

  }

  fetchClientSecret = async () => {

    this.isLoading = true;
    var stripe = await loadStripe(environment.stripeCheckoutPublicKey);

    if (this.appearanceModel === undefined) {
      this.appearanceModel = this.queryAndSetAppearance();
    }

    var appearance = this.appearanceModel;

    this.checkoutApiService.createCheckoutSession([{
      "productType": ProductType[this.singlePackageCheckout!.customFields?.find(x => x.name === 'ProductType')?.value],
      "productId": `${this.singlePackageCheckout?.id}`,
      "signUrl": `${window.location.protocol + "//" + window.location.host + ''}`
    }]).subscribe(async (result: any) => {
      if (result) {
        this.tabId = 2;
        if (stripe !== null) {
          try {
            this.localCheckout = await stripe.initCheckout({
              fetchClientSecret: () => result.clientSecret,
              elementsOptions: { appearance },
            });
          } catch (error) {
            this.submitted = false;
            this.isLoading = false;
            this.toasterNotificationService.showError('Checkout initialization failed, please try again later.', 'Error')
          }

          this.checkoutSessionId = result.id;
          this.localPaymentElement = this.localCheckout.createPaymentElement();
          this.localPaymentElement.mount("#payment-element");
        }
        this.submitted = false;
        this.isLoading = false;
      } else {
        this.submitted = false;
        this.isLoading = false;
      }
    });

  }


  tabToInfo() {
    this.tabId = 1;
  }

  tabToFinish() {

    this.submitted = true;
    this.isLoading = true;

    if (this.validateCreditCardInfo()) {
      this.myfileApiService.isCreditCardValid(this.userModel.paymentInfo).subscribe((ccValidationResult: any) => {
        if (ccValidationResult) {
          if (this.singleRequisitionModel) {
            this.checkoutRequisition();
          } else if (this.singlePackageCheckout) {
            this.checkoutMarketplacePackage();
          }
        } else {
          this.submitted = false;
          this.isLoading = false;
        }
      })
    } else {
      this.submitted = false;
      this.toasterNotificationService.showError($localize`:@@Toast_Error_CartCheckoutInfo: Please check your credit card information is valid.`, $localize`:@@Toast_Error_CartCheckoutFailedTitle: Cart Checkout Failed`);
      this.isLoading = false;
    }

    // }
  }
  checkoutRequisition() {
    Swal.fire({
      title: $localize`:@@:Checkout`,
      text: $localize`:@@:Your credit card will not be charged until your Requisitions are processed by the MyFile Team. Do you want to proceed?`,
      icon: 'warning',
      color: 'var(--vz-bod∂y-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@:Ok`,
      cancelButtonText: $localize`:@@:Cancel`,
    }).then(result => {
      if (this.singleRequisitionModel) {
        if (result && result.isConfirmed && this.singleRequisitionModel.id) {

          this.myfileApiService.updateUser(this.userModel).subscribe((userUpdateResult: any) => {
            if (userUpdateResult) {

              var checkoutInfo = new CheckoutInfoModel();
              var productInfo = new ProductInfoModel();

              productInfo.productType = ProductType.Requisition;
              productInfo.productId = this.singleRequisitionModel!.id

              checkoutInfo.products.push(productInfo);

              this.checkoutApiService.cartCheckout(checkoutInfo).subscribe((result: CheckoutResultInfoModel | undefined) => {
                if (result) {
                  this.singleRequisitionModel!.status = RequisitionStatus.Submitted;
                  this.tabId = 3;
                }
                else {
                  this.tabId = 3;
                  this.toasterNotificationService.showError($localize`:@@Toast_Error_CartCheckoutFailed: Please check your Draft requisitions for validity and try again.`, $localize`:@@Toast_Error_CartCheckoutFailedTitle: Cart Checkout Failed`);
                }
                this.badgeCountService.getBadgeCount();
              });
            }
            this.submitted = false;
            this.isLoading = false;
          });
        } else {
          this.submitted = false;
          this.isLoading = false;
        }
      }
    });

  }

  checkoutMarketplacePackage() {
    if (this.singlePackageCheckout) {

      this.myfileApiService.updateUser(this.userModel).subscribe((userUpdateResult: any) => {
        if (userUpdateResult) {

          var checkoutInfo = new CheckoutInfoModel();
          var productInfo = new ProductInfoModel();
          
          productInfo.productType = ProductType[this.singlePackageCheckout!.customFields?.find(x => x.name === 'ProductType')?.value]
          productInfo.productType = 100;
          productInfo.productId = this.singlePackageCheckout!.id;

          checkoutInfo.products.push(productInfo);

          this.checkoutApiService.cartCheckout(checkoutInfo).subscribe((result: CheckoutResultInfoModel | undefined) => {
            if (result && result.checkoutResults && result.checkoutResults[0]) {
              if (result.checkoutResults[0].succeeded) {
                this.checkoutSucceeded = true;
                this.tabId = 3;
              } else {
                this.toasterNotificationService.showError(`${result.checkoutResults[0].failureReason}`, $localize`:@@Toast_Error_CartCheckoutFailedTitle: Cart Checkout Failed`);
              }
            } else {
              this.toasterNotificationService.showError($localize`:@@: Please check request for validity and try again.`, $localize`:@@Toast_Error_CartCheckoutFailedTitle: Cart Checkout Failed`);
            }

          });
        }
        this.submitted = false;
        this.isLoading = false;
      });

    }

  }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    if (changeEvent.nextId == (1)) {
      if (this.checkoutSucceeded === true) {
        changeEvent.preventDefault();
      }
    }
    if (changeEvent.nextId == (2)) {
      changeEvent.preventDefault();
    }
    if (changeEvent.nextId == (3)) {
      changeEvent.preventDefault();
    }
  }

  close() {
    this.modalRef.close();
  }
}
